module.exports = __webpack_public_path__ + "img/img1.bb2e9f71.jpg";